var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHand2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 302.57 425.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#da004f;}.cls-12,.cls-2,.cls-5{fill:#fff;}.cls-10,.cls-11,.cls-12,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9{stroke:#000;stroke-miterlimit:10;}.cls-2{stroke-width:1.59px;}.cls-3{fill:#da00c6;}.cls-3,.cls-4{stroke-width:1.47px;}.cls-4{fill:#f0c62f;}.cls-5{stroke-width:1.16px;}.cls-6,.cls-7{fill:#ffbace;}.cls-6{stroke-width:0.45px;}.cls-7{stroke-width:0.67px;}.cls-8{fill:#c6495d;}.cls-10,.cls-8,.cls-9{stroke-width:0.18px;}.cls-9{fill:#0f1a67;}.cls-10{fill:#7c7bd4;}.cls-11{fill:#77c12d;stroke-width:0.73px;}.cls-12{stroke-width:1.15px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.58,205.41s-24.74-132.2,18.76-116a7.73,7.73,0,0,1,6.82-6c6-.85,13.65-1.7,21.33,5.12,0,0-18.77-65.67-16.21-75A17.4,17.4,0,0,1,82.52,1.57s6.82-3.42,15.35,4.26c9.42,8.48,23.88,74.2,23.88,74.2s15.35-59.7,19.62-70.79a13.73,13.73,0,0,1,7.27-7.84,16.66,16.66,0,0,1,17.07,2.31,13.82,13.82,0,0,1,5.51,8.09c1.7,8.53-17.91,93-17.91,93L133.69,205.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.6,58.37c1.75,5.46,3.38,11,5,16.45s3.22,11,4.78,16.51c3.14,11,6.15,22.08,9.12,33.15l-.74-.85L111.21,129l12.38,5.39,1.36.59-.91,1.12a57.76,57.76,0,0,1-7.59,7.65,35.44,35.44,0,0,1-9.16,5.72,18,18,0,0,1-5.31,1.31,12.63,12.63,0,0,1-5.42-.74c-3.46-1.35-5.91-4.24-7.65-7.27,2,2.86,4.64,5.45,7.93,6.47s6.8.31,9.88-1.1a36.16,36.16,0,0,0,8.48-5.83,60.94,60.94,0,0,0,7.08-7.57l.45,1.7-12.49-5.16L97.8,126l-.58-.25-.16-.6c-2.92-11.08-5.82-22.17-8.57-33.3-1.39-5.55-2.73-11.13-4.07-16.7S81.8,64,80.6,58.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.36,135a50.25,50.25,0,0,0,2.74,6,45.7,45.7,0,0,0,3.48,5.58A27.15,27.15,0,0,0,68,151.42a14.76,14.76,0,0,0,5.59,3c4.06,1.16,8.53-.38,11.72-2.95a10.8,10.8,0,0,0,3.09-5.22,21.59,21.59,0,0,0,.69-6.28,47.37,47.37,0,0,0-2.31-12.7,71.74,71.74,0,0,0-5-12,72,72,0,0,0-7.07-10.92,47.41,47.41,0,0,0-9.17-9A23.59,23.59,0,0,0,54,90.53a15.85,15.85,0,0,0-6.09.56,13.31,13.31,0,0,0-1.46.51l-.36.14-.18.07,0,0-.06,0a6.23,6.23,0,0,0-.56.35,11.89,11.89,0,0,0-2.16,2.05c-2.6,3.2-4.09,7.35-5,11.53a111.18,111.18,0,0,0-1.8,13c-.74,8.76-.94,17.59-.88,26.4q0,6.63.24,13.24.14,3.3.37,6.6a46.73,46.73,0,0,0,.77,6.57A85.33,85.33,0,0,1,35,158.44c-.37-4.41-.63-8.83-.82-13.25-.31-8.84-.33-17.7.18-26.57a97,97,0,0,1,1.56-13.3,29.86,29.86,0,0,1,5.35-12.59,13.31,13.31,0,0,1,2.61-2.52,6.72,6.72,0,0,1,.84-.53l.12-.06.15-.07.2-.08.41-.16a15.67,15.67,0,0,1,1.67-.58,18.51,18.51,0,0,1,7-.69A26.21,26.21,0,0,1,67,93.27a50.36,50.36,0,0,1,9.64,9.54,71.23,71.23,0,0,1,7.24,11.34,73.33,73.33,0,0,1,5,12.47A46.44,46.44,0,0,1,91.05,140a23.29,23.29,0,0,1-1,6.81,12.28,12.28,0,0,1-3.75,5.92,13.88,13.88,0,0,1-3,1.85,17.58,17.58,0,0,1-3.25,1.2,12.64,12.64,0,0,1-6.9-.12,15.87,15.87,0,0,1-5.86-3.47A27.5,27.5,0,0,1,63,147,46.7,46.7,0,0,1,57.36,135Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.46,204.17H168.16a0,0,0,0,1,0,0V367.23a29.24,29.24,0,0,1-29.24,29.24H70.7a29.24,29.24,0,0,1-29.24-29.24V204.17A0,0,0,0,1,41.46,204.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M168.66,205.41l-1.28-82.31s.85-20.47-27.29-20.47-64,1.71-64,1.71-9.38.85-8.53,16.2S99.15,135,99.15,135h27.29s-36.67,9.39-36.67,35.83S91,205.41,91,205.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.77,170.87a18.61,18.61,0,0,1,.36-6.89,22.74,22.74,0,0,1,1-3.33c.42-1.08.93-2.13,1.43-3.18s1.18-2,1.83-3l2.12-2.77,2.41-2.54a11,11,0,0,1,1.27-1.19l1.33-1.13,1.34-1.13c.44-.38.94-.68,1.42-1l2.88-2c1-.63,2-1.14,3-1.72s2-1.17,3.07-1.66c2.12-.94,4.22-2,6.37-2.82l6.54-2.38.37,1.81a181.73,181.73,0,0,1-23,.95c-7.67-.21-15.41-.77-22.94-2.95a35.73,35.73,0,0,1-5.54-2.09,19.8,19.8,0,0,1-5-3.39,11.68,11.68,0,0,1-3.31-5.39,9.74,9.74,0,0,1-.32-1.59c0-.54-.09-1.07-.09-1.54,0-1,0-2,0-2.94a27.61,27.61,0,0,1,.79-5.94,13.07,13.07,0,0,1,2.9-5.56,11.93,11.93,0,0,1,5.44-3.19,26.56,26.56,0,0,1,5.91-.91c3.91-.2,7.73,0,11.53,0s7.58,0,11.39-.07c7.62-.15,15.25-.4,22.9-.38,3.82,0,7.65.09,11.48.32a67.85,67.85,0,0,1,11.42,1.54,21.65,21.65,0,0,1,5.47,2,32.59,32.59,0,0,1,4.71,3.34,22.35,22.35,0,0,1,3.9,4.23,13.41,13.41,0,0,1,2.32,5.22,13.1,13.1,0,0,0-2.56-5,23.6,23.6,0,0,0-4-4,32.66,32.66,0,0,0-4.74-3.09,21.41,21.41,0,0,0-5.31-1.71,75.77,75.77,0,0,0-11.28-1.13c-3.79-.14-7.59-.13-11.39,0-7.61.16-15.22.6-22.85.91-3.81.14-7.66.25-11.49.21s-7.63-.14-11.35.1-7.43.9-9.67,3.36a10.36,10.36,0,0,0-2.29,4.5,25.08,25.08,0,0,0-.69,5.38c0,.93,0,1.85,0,2.79a9.74,9.74,0,0,0,.32,2.53,9.14,9.14,0,0,0,2.6,4.23c2.53,2.39,6,3.87,9.54,4.93a68.55,68.55,0,0,0,11,2.19c3.74.47,7.51.73,11.3.86s7.57.13,11.37,0,7.6-.25,11.35-.56l7.6-.63-7.22,2.44-6.49,2.19c-2.14.79-4.21,1.75-6.32,2.62-1,.45-2,1-3,1.55s-2,1-3,1.62L105,145.77c-.47.32-1,.59-1.43.94l-1.33,1.06-1.35,1a10.4,10.4,0,0,0-1.28,1.11l-2.45,2.38L95,154.94c-.67.92-1.26,1.89-1.89,2.84s-1.07,2-1.53,3.05a28.12,28.12,0,0,0-1.11,3.24A18.55,18.55,0,0,0,89.77,170.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.34,89.41a6.1,6.1,0,0,1,1.29-4.06,8.84,8.84,0,0,1,3.55-2.68,17.68,17.68,0,0,1,8.56-1.08A31.84,31.84,0,0,1,82,83.4a15.43,15.43,0,0,1,3.78,2A8.38,8.38,0,0,1,87.29,87a3.59,3.59,0,0,1,.77,2,3.92,3.92,0,0,0-1.28-1.51,9,9,0,0,0-1.67-1,20.51,20.51,0,0,0-3.72-1.22,64.58,64.58,0,0,0-7.87-1.14,22.67,22.67,0,0,0-7.65.42,8.76,8.76,0,0,0-3.31,1.66A6.94,6.94,0,0,0,60.34,89.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.32,240.94s49.18-3.25,49.08,20.23l-.47-20.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.32,240.94a105.29,105.29,0,0,1,14.65-.43,84.19,84.19,0,0,1,14.63,1.74c4.8,1.1,9.65,2.63,13.85,5.62a17.79,17.79,0,0,1,5.27,5.7,15.64,15.64,0,0,1,1.94,7.61l-2.51,0c-.21-6.87-.3-13.75-.44-20.63l1.23,1.2-12.49-.1c-4.16-.08-8.32-.19-12.41-.31C134.87,241.07,127,240.88,119.32,240.94Zm0,0c8.51-.07,16.86-.4,24.89-.81l11.9-.52,11.81-.28,1.2,0,0,1.22c.18,6.87.4,13.75.51,20.62l-2.51,0a13.24,13.24,0,0,0-1.59-6.41,16.07,16.07,0,0,0-4.48-5,27.94,27.94,0,0,0-6.13-3.4,52.47,52.47,0,0,0-6.79-2.26,96,96,0,0,0-14.27-2.43Q126.65,240.94,119.32,240.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168,192c.69,9.84,1.08,19.69,1.37,29.54.18,4.93.24,9.85.36,14.78l.18,14.77,0,14.78c-.05,4.92-.05,9.85-.15,14.78-.15,9.85-.41,19.7-1,29.56-.7-9.85-1.1-19.7-1.38-29.55-.18-4.92-.24-9.85-.36-14.77l-.18-14.78,0-14.77c0-4.93,0-9.86.15-14.78C167.2,211.68,167.46,201.82,168,192Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M40.88,252.64c-.13-2.09-.21-4.59-.47-7.07-.43-4.1-.78-8.22-1.53-12.27-1.83-9.85-6.52-14.65-16.4-16.37-5.82-1-11.77-1.33-17.67-2a5,5,0,0,1-1.87-.39c2.38-.15,4.77-.17,7.14-.46,4.83-.59,9.7-1.08,14.46-2,7.48-1.51,12.06-6.21,13.91-13.63,1.62-6.54,2-13.21,2.42-19.89a10.59,10.59,0,0,1,.3-2c.37,4.53.66,9.08,1.13,13.6a71.77,71.77,0,0,0,1.27,7.58c1.7,8.1,6.66,13.16,14.77,14.6,6.12,1.08,12.36,1.52,18.55,2.22a18.6,18.6,0,0,0,2.24,0l0,.41c-.53,0-1.07.05-1.61.1-6.19.66-12.42,1.08-18.57,2-9.26,1.47-14.44,7.28-15.82,16.4C42.19,240,41.6,246.49,40.88,252.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M238.8,360.23a191.64,191.64,0,0,0-62.68,0H139v20.66c0,12.84,30.64,23.25,68.44,23.25s68.44-10.41,68.44-23.25V360.23Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 207.46,
    cy: 360.23,
    rx: 68.44,
    ry: 23.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.75,360.26l-.31-1.23c-.06-.27.07-.48.41-.64a3.22,3.22,0,0,1,1.24-.24l7.2,0a4.4,4.4,0,0,1,.68-3.91,8.75,8.75,0,0,1,3.65-2.7,20.2,20.2,0,0,1,5.73-1.41,36.89,36.89,0,0,1,7.22,0,24.37,24.37,0,0,1,5.6,1.06,19.42,19.42,0,0,1,4.09,1.87,17.82,17.82,0,0,1,3.06,2.39c.89.87,1.72,1.73,2.5,2.61l19.57-.07A6.39,6.39,0,0,0,227,356.2a19,19,0,0,0-1.67-1.35c-.55-.38-1-.71-1.45-1s-.64-.49-.68-.67a.41.41,0,0,1,.16-.47,2.19,2.19,0,0,1,.79-.35l2.37-.7a23.5,23.5,0,0,1,4.65,2.71,9.82,9.82,0,0,1,3,3.55l7.83,0,.31,1.23c.06.25-.08.46-.43.62a3.2,3.2,0,0,1-1.28.25l-5.82,0a4.28,4.28,0,0,1-.59,3.71,7.9,7.9,0,0,1-3.28,2.55,17.58,17.58,0,0,1-5.15,1.35,30.71,30.71,0,0,1-6.38.06,27.26,27.26,0,0,1-5.75-1,19.73,19.73,0,0,1-4.17-1.77,16.66,16.66,0,0,1-3.05-2.26c-.85-.82-1.64-1.65-2.36-2.49l-21.51.08a6.78,6.78,0,0,0,1.83,2.3,20.56,20.56,0,0,0,2.34,1.68c.77.48,1.44.88,2,1.2s.91.59,1,.82c.09.39-.17.67-.79.86L186,368a25.34,25.34,0,0,1-5.77-3.45,11.49,11.49,0,0,1-3.44-4.3Zm56,4.36a9,9,0,0,0,2.86-.74,4.52,4.52,0,0,0,1.87-1.51,3.49,3.49,0,0,0,.56-2.32l-18.25.06c.57.57,1.16,1.1,1.78,1.61a13,13,0,0,0,2.05,1.35,14.38,14.38,0,0,0,2.49,1,15.57,15.57,0,0,0,3.07.56A18.41,18.41,0,0,0,223.71,364.62Zm-35.48-11.44a11.32,11.32,0,0,0-3.44.85,5.21,5.21,0,0,0-2.16,1.65,3.67,3.67,0,0,0-.67,2.42L202.2,358c-.55-.6-1.12-1.17-1.72-1.72a12.08,12.08,0,0,0-2-1.45,13,13,0,0,0-2.53-1.09,15.09,15.09,0,0,0-3.2-.59A23.32,23.32,0,0,0,188.23,353.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M238.8,316.33a190.91,190.91,0,0,0-62.68,0H139V337c0,12.84,30.64,23.24,68.44,23.24S275.9,349.83,275.9,337V316.33Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 207.46,
    cy: 316.33,
    rx: 68.44,
    ry: 23.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.75,316.35l-.31-1.23c-.06-.27.07-.48.41-.63a3,3,0,0,1,1.24-.24l7.2,0a4.42,4.42,0,0,1,.68-3.92,8.75,8.75,0,0,1,3.65-2.7,19.88,19.88,0,0,1,5.73-1.4,36.85,36.85,0,0,1,7.22,0,24.34,24.34,0,0,1,5.6,1.07,18.93,18.93,0,0,1,4.09,1.87,17.3,17.3,0,0,1,3.06,2.38c.89.87,1.72,1.74,2.5,2.61l19.57-.06a6.43,6.43,0,0,0-1.37-1.75,18.84,18.84,0,0,0-1.67-1.34c-.55-.39-1-.71-1.45-1s-.64-.49-.68-.67a.43.43,0,0,1,.16-.48,2.21,2.21,0,0,1,.79-.34l2.37-.7a23,23,0,0,1,4.65,2.71,9.79,9.79,0,0,1,3,3.54l7.83,0,.31,1.23c.06.26-.08.47-.43.62a3,3,0,0,1-1.28.25l-5.82,0a4.26,4.26,0,0,1-.59,3.7,7.9,7.9,0,0,1-3.28,2.55,17.27,17.27,0,0,1-5.15,1.35,31.38,31.38,0,0,1-6.38.07,27.92,27.92,0,0,1-5.75-1,19.73,19.73,0,0,1-4.17-1.78,16.21,16.21,0,0,1-3.05-2.26c-.85-.82-1.64-1.65-2.36-2.49l-21.51.08a6.92,6.92,0,0,0,1.83,2.31,21.88,21.88,0,0,0,2.34,1.68c.77.47,1.44.87,2,1.19s.91.6,1,.83c.09.39-.17.67-.79.85l-2.89.9a25.32,25.32,0,0,1-5.77-3.44,11.65,11.65,0,0,1-3.44-4.3Zm56,4.37a9.28,9.28,0,0,0,2.86-.74,4.54,4.54,0,0,0,1.87-1.52,3.48,3.48,0,0,0,.56-2.32l-18.25.07c.57.56,1.16,1.1,1.78,1.6a12.36,12.36,0,0,0,2.05,1.36,14.37,14.37,0,0,0,2.49,1,15.57,15.57,0,0,0,3.07.56A19.28,19.28,0,0,0,223.71,320.72Zm-35.48-11.44a11.33,11.33,0,0,0-3.44.84,5.21,5.21,0,0,0-2.16,1.65,3.69,3.69,0,0,0-.67,2.42l20.24-.06c-.55-.6-1.12-1.17-1.72-1.71a12.13,12.13,0,0,0-2-1.46,12.43,12.43,0,0,0-2.53-1.08,15.06,15.06,0,0,0-3.2-.6A24.1,24.1,0,0,0,188.23,309.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M238.8,269.84a191.64,191.64,0,0,0-62.68,0H139V290.5c0,12.84,30.64,23.24,68.44,23.24s68.44-10.4,68.44-23.24V269.84Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 207.46,
    cy: 269.84,
    rx: 68.44,
    ry: 23.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.75,269.87l-.31-1.24c-.06-.27.07-.48.41-.63a3.22,3.22,0,0,1,1.24-.24l7.2,0a4.42,4.42,0,0,1,.68-3.92,8.84,8.84,0,0,1,3.65-2.7,20.21,20.21,0,0,1,5.73-1.4,36.85,36.85,0,0,1,7.22,0,24.34,24.34,0,0,1,5.6,1.07,19.42,19.42,0,0,1,4.09,1.87,17.78,17.78,0,0,1,3.06,2.38c.89.87,1.72,1.74,2.5,2.61l19.57-.06A6.43,6.43,0,0,0,227,265.8a18.84,18.84,0,0,0-1.67-1.34c-.55-.39-1-.71-1.45-1s-.64-.49-.68-.67a.43.43,0,0,1,.16-.48,2.21,2.21,0,0,1,.79-.34l2.37-.7a23,23,0,0,1,4.65,2.71,9.79,9.79,0,0,1,3,3.54l7.83,0,.31,1.23c.06.26-.08.47-.43.63a3.21,3.21,0,0,1-1.28.24l-5.82,0a4.29,4.29,0,0,1-.59,3.71,8.06,8.06,0,0,1-3.28,2.55,17.59,17.59,0,0,1-5.15,1.34,30.68,30.68,0,0,1-6.38.07,27.26,27.26,0,0,1-5.75-1,20.26,20.26,0,0,1-4.17-1.77,16.66,16.66,0,0,1-3.05-2.26c-.85-.83-1.64-1.66-2.36-2.5l-21.51.08a6.72,6.72,0,0,0,1.83,2.31,20.56,20.56,0,0,0,2.34,1.68c.77.47,1.44.87,2,1.19s.91.6,1,.83c.09.39-.17.67-.79.86l-2.89.9a25.7,25.7,0,0,1-5.77-3.45,11.65,11.65,0,0,1-3.44-4.3Zm56,4.36a9.28,9.28,0,0,0,2.86-.74,4.46,4.46,0,0,0,1.87-1.52,3.45,3.45,0,0,0,.56-2.31l-18.25.06c.57.56,1.16,1.1,1.78,1.6a12.36,12.36,0,0,0,2.05,1.36,13.62,13.62,0,0,0,2.49,1,14.88,14.88,0,0,0,3.07.56A18.45,18.45,0,0,0,223.71,274.23Zm-35.48-11.44a11.33,11.33,0,0,0-3.44.84,5.21,5.21,0,0,0-2.16,1.65,3.69,3.69,0,0,0-.67,2.42l20.24-.06c-.55-.6-1.12-1.17-1.72-1.71a11.54,11.54,0,0,0-2-1.45,13,13,0,0,0-2.53-1.09,15.06,15.06,0,0,0-3.2-.6A24.1,24.1,0,0,0,188.23,262.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M238.8,225.93a191.64,191.64,0,0,0-62.68,0H139v20.66c0,12.84,30.64,23.25,68.44,23.25s68.44-10.41,68.44-23.25V225.93Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 207.46,
    cy: 225.93,
    rx: 68.44,
    ry: 23.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.75,226l-.31-1.23c-.06-.27.07-.48.41-.64a3.22,3.22,0,0,1,1.24-.24l7.2,0a4.4,4.4,0,0,1,.68-3.91,8.75,8.75,0,0,1,3.65-2.7,20.2,20.2,0,0,1,5.73-1.41,36.89,36.89,0,0,1,7.22,0,24.37,24.37,0,0,1,5.6,1.06,19.42,19.42,0,0,1,4.09,1.87,17.82,17.82,0,0,1,3.06,2.39c.89.87,1.72,1.74,2.5,2.61l19.57-.07A6.39,6.39,0,0,0,227,221.9a17.19,17.19,0,0,0-1.67-1.34c-.55-.39-1-.72-1.45-1s-.64-.49-.68-.67a.41.41,0,0,1,.16-.47,2.19,2.19,0,0,1,.79-.35l2.37-.7a24,24,0,0,1,4.65,2.71,9.82,9.82,0,0,1,3,3.55l7.83,0,.31,1.23c.06.26-.08.46-.43.62a3.2,3.2,0,0,1-1.28.25l-5.82,0a4.28,4.28,0,0,1-.59,3.71,7.9,7.9,0,0,1-3.28,2.55,17.58,17.58,0,0,1-5.15,1.35,31.38,31.38,0,0,1-6.38.07,27.87,27.87,0,0,1-5.75-1,19.23,19.23,0,0,1-4.17-1.77,16.21,16.21,0,0,1-3.05-2.26c-.85-.82-1.64-1.65-2.36-2.49l-21.51.08a6.78,6.78,0,0,0,1.83,2.3,22,22,0,0,0,2.34,1.69c.77.47,1.44.87,2,1.19s.91.59,1,.83-.17.67-.79.85l-2.89.9a25,25,0,0,1-5.77-3.45,11.49,11.49,0,0,1-3.44-4.3Zm56,4.36a9,9,0,0,0,2.86-.74,4.44,4.44,0,0,0,1.87-1.51,3.49,3.49,0,0,0,.56-2.32l-18.25.06c.57.57,1.16,1.1,1.78,1.61a13,13,0,0,0,2.05,1.35,14.38,14.38,0,0,0,2.49,1,15.57,15.57,0,0,0,3.07.56A18.41,18.41,0,0,0,223.71,230.32Zm-35.48-11.44a11.62,11.62,0,0,0-3.44.85,5.21,5.21,0,0,0-2.16,1.65,3.67,3.67,0,0,0-.67,2.42l20.24-.06c-.55-.6-1.12-1.17-1.72-1.72a12.08,12.08,0,0,0-2-1.45,13,13,0,0,0-2.53-1.09,15.09,15.09,0,0,0-3.2-.59A24.15,24.15,0,0,0,188.23,218.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.9,267.26c-2.58-5.17-9.39-9.08-9.39-9.08-9.39,6.42-29.8,9.15-29.8,9.15a41.82,41.82,0,0,0,15.95-.07c5-1.05,7.81-2.7,12.91-2.59A24.92,24.92,0,0,1,275.9,267.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.11,312.06c-2.58-5.17-9.39-9.08-9.39-9.08-9.39,6.42-29.8,9.15-29.8,9.15a41.82,41.82,0,0,0,16-.07c5-1.05,7.81-2.7,12.91-2.59A24.92,24.92,0,0,1,274.11,312.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.9,357.68c-2.58-5.16-9.39-9.07-9.39-9.07-9.39,6.42-29.8,9.14-29.8,9.14a41.62,41.62,0,0,0,15.95-.07c5-1,7.81-2.69,12.91-2.58A24.93,24.93,0,0,1,275.9,357.68Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 16.55,
    y: 255.75,
    width: 70.25,
    height: 135.09,
    rx: 8.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 31.39,
    y: 366.05,
    width: 40.53,
    height: 12.16,
    rx: 4.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 16.55,
    y1: 274.09,
    x2: 86.33,
    y2: 274.09
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 25.63,
    cy: 266.26,
    r: 2.91
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 33.99,
    cy: 266.26,
    r: 2.91
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 42.35,
    cy: 266.26,
    r: 2.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 22.81,
    y1: 298.69,
    x2: 80.07,
    y2: 298.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 22.81,
    y1: 305.4,
    x2: 80.07,
    y2: 305.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 22.81,
    y1: 313.01,
    x2: 80.07,
    y2: 313.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 22.81,
    y1: 313.01,
    x2: 80.07,
    y2: 313.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 22.81,
    y1: 319.72,
    x2: 80.07,
    y2: 319.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 22.81,
    y1: 326.43,
    x2: 80.07,
    y2: 326.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 22.81,
    y1: 333.14,
    x2: 80.07,
    y2: 333.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 22.81,
    y1: 340.74,
    x2: 80.07,
    y2: 340.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 22.81,
    y1: 347.45,
    x2: 80.07,
    y2: 347.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 22.81,
    y1: 340.74,
    x2: 80.07,
    y2: 340.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 22.81,
    y1: 347.45,
    x2: 80.07,
    y2: 347.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 21.02,
    y: 272.75,
    width: 70.25,
    height: 135.09,
    rx: 8.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 35.86,
    y: 383.05,
    width: 40.53,
    height: 12.16,
    rx: 4.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 21.02,
    y1: 291.09,
    x2: 90.8,
    y2: 291.09
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 30.11,
    cy: 283.26,
    r: 2.91
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 38.47,
    cy: 283.26,
    r: 2.91
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 46.83,
    cy: 283.26,
    r: 2.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 27.28,
    y1: 315.69,
    x2: 84.54,
    y2: 315.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 27.28,
    y1: 322.4,
    x2: 84.54,
    y2: 322.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 27.28,
    y1: 330.01,
    x2: 84.54,
    y2: 330.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 27.28,
    y1: 330.01,
    x2: 84.54,
    y2: 330.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 27.28,
    y1: 336.72,
    x2: 84.54,
    y2: 336.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 27.28,
    y1: 343.43,
    x2: 84.54,
    y2: 343.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 27.28,
    y1: 350.14,
    x2: 84.54,
    y2: 350.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 27.28,
    y1: 357.74,
    x2: 84.54,
    y2: 357.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 27.28,
    y1: 364.45,
    x2: 84.54,
    y2: 364.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 27.28,
    y1: 357.74,
    x2: 84.54,
    y2: 357.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 27.28,
    y1: 364.45,
    x2: 84.54,
    y2: 364.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 26.39,
    y: 289.75,
    width: 70.25,
    height: 135.09,
    rx: 8.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 41.23,
    y: 400.05,
    width: 40.53,
    height: 12.16,
    rx: 4.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 26.39,
    y1: 308.09,
    x2: 96.17,
    y2: 308.09
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 35.47,
    cy: 300.26,
    r: 2.91
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 43.83,
    cy: 300.26,
    r: 2.91
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 52.19,
    cy: 300.26,
    r: 2.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 32.65,
    y1: 332.69,
    x2: 89.91,
    y2: 332.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 32.65,
    y1: 339.4,
    x2: 89.91,
    y2: 339.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 32.65,
    y1: 347.01,
    x2: 89.91,
    y2: 347.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 32.65,
    y1: 347.01,
    x2: 89.91,
    y2: 347.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 32.65,
    y1: 353.72,
    x2: 89.91,
    y2: 353.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 32.65,
    y1: 360.43,
    x2: 89.91,
    y2: 360.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 32.65,
    y1: 367.14,
    x2: 89.91,
    y2: 367.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 32.65,
    y1: 374.74,
    x2: 89.91,
    y2: 374.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 32.65,
    y1: 381.45,
    x2: 89.91,
    y2: 381.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 32.65,
    y1: 374.74,
    x2: 89.91,
    y2: 374.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 32.65,
    y1: 381.45,
    x2: 89.91,
    y2: 381.45
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M274.24,380.53c-.1-1.51-.15-3.32-.34-5.12-.32-3-.57-6-1.11-8.88-1.33-7.12-4.72-10.61-11.87-11.85-4.22-.73-8.52-1-12.79-1.41a3.59,3.59,0,0,1-1.35-.28c1.72-.11,3.45-.12,5.16-.33,3.5-.43,7-.79,10.47-1.48,5.41-1.1,8.73-4.49,10.07-9.87a78.28,78.28,0,0,0,1.75-14.39,7.36,7.36,0,0,1,.22-1.47c.26,3.29.47,6.58.81,9.85a53.74,53.74,0,0,0,.92,5.49c1.24,5.86,4.82,9.52,10.69,10.56,4.44.78,8.95,1.1,13.43,1.61a14.58,14.58,0,0,0,1.62,0l0,.3c-.39,0-.78,0-1.16.08-4.49.47-9,.78-13.44,1.48-6.71,1.06-10.46,5.27-11.46,11.87C275.19,371.37,274.76,376.08,274.24,380.53Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHand2);
export default __webpack_public_path__ + "static/media/hand2.179718b6e8079b9457209796195f4f82.svg";
export { ForwardRef as ReactComponent };